// extracted by mini-css-extract-plugin
module.exports = {"section":"MoreOrganizerEventsRedesign_section__8NGP3","emptyState":"MoreOrganizerEventsRedesign_emptyState__bDNz3"};